export { useCardFooterBase_unstable as useCardFooter } from '@fluentui/react-card';
